import { render, staticRenderFns } from "./BusinessInfo.vue?vue&type=template&id=d493b120"
import script from "./BusinessInfo.vue?vue&type=script&lang=js"
export * from "./BusinessInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports